import { currencyParser, customDateFormat, customParseFloat, durationToDaysParser } from '../../misc'

const genericLiquidateContentParser = portfolio => {
  const customStatusName = state => (['requested', 'owner_sign_pending'].includes(state) ? 'Processing' : 'Processed')

  return [
    {
      type: 'investmentAmount',
      title: 'Amount Deployed',
      val: currencyParser(portfolio?.investmentAmount),
    },
    {
      type: 'netIRR',
      title: 'Net IRR',
      val: customParseFloat(portfolio?.netIRR),
    },
    {
      type: 'liquidationAmount',
      title: 'Liquidation amount',
      val: currencyParser(portfolio?.liquidationAmount),
    },
    {
      type: 'liquidationRequestedDate',
      title: 'Requested on',
      val: customDateFormat(portfolio?.liquidationRequestedDate),
    },
    {
      type: 'duration',
      title: 'Effective tenure',
      val: durationToDaysParser(portfolio?.duration),
    },
    {
      type: 'liquidationExpiryDate',
      title: 'Liquidation expires on',
      val: customDateFormat(portfolio?.liquidationExpiryDate),
    },
    {
      type: 'state',
      title: 'Status',
      val: customStatusName(portfolio?.state),
    },
  ]
}

export const liquidateContentParser = portfolio => {
  return genericLiquidateContentParser(portfolio)
}
